import React from 'react'

export default function FormIconForm (props) {
  return (
    <svg
      width="94"
      height="88"
      viewBox="0 0 94 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      {...props}
    >
      <path
        d="M0.654297 0H50.7746L68.9701 18.1403V88L0.654297 88V0Z"
        fill="#05AAC0"
      />
      <line
        x1="13.2246"
        y1="16.203"
        x2="46.3918"
        y2="16.203"
        stroke="white"
        strokeWidth="2"
      />
      <line
        x1="13.2246"
        y1="24.5358"
        x2="54.2472"
        y2="24.5358"
        stroke="white"
        strokeWidth="2"
      />
      <line
        x1="13.2246"
        y1="32.6307"
        x2="54.2472"
        y2="32.6307"
        stroke="white"
        strokeWidth="2"
      />
      <line
        x1="13.2246"
        y1="40.7256"
        x2="54.2472"
        y2="40.7256"
        stroke="white"
        strokeWidth="2"
      />
      <line
        x1="13.2246"
        y1="48.8205"
        x2="54.2472"
        y2="48.8205"
        stroke="white"
        strokeWidth="2"
      />
      <line
        x1="13.2246"
        y1="73.1053"
        x2="54.2472"
        y2="73.1053"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M50.8291 2.82972e-05L50.8291 18.2374L69.0664 18.2374L50.8291 2.82972e-05Z"
        fill="#0185A2"
      />
      <path
        d="M50.8291 2.82972e-05L50.8291 18.2374L69.0664 18.2374L50.8291 2.82972e-05Z"
        stroke="white"
      />
      <rect
        x="84.4707"
        y="30.3224"
        width="8.43517"
        height="37.9582"
        transform="rotate(45 84.4707 30.3224)"
        fill="#1D1F21"
      />
      <path
        d="M55.4619 65.2963L57.6309 57.1628L63.5954 63.1274L55.4619 65.2963Z"
        fill="#1D1F21"
      />
      <path
        d="M93.4805 33.2787L87.5067 27.305L83.7111 31.1006L89.6848 37.0744L93.4805 33.2787Z"
        fill="#FD7A7D"
      />
    </svg>
  )
}
